import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import TeamView from "../views/TeamView.vue";
import ItemCustomView from "../views/ItemCustomView.vue";
import ArticlesListView from "../views/ArticlesListView.vue";
import ArticlesItemView from "../views/ArticlesItemView.vue";
import GalleriesListView from "../views/GalleriesListView.vue";
import GalleriesItemView from "../views/GalleriesItemView.vue";
import SchoolCalendarView from "../views/SchoolCalendarView.vue";
import ContactView from "../views/ContactView.vue";
import ContactResponseView from "../views/ContactResponseView.vue";
import WorkWithUsView from "../views/WorkWithUsView.vue";
import WorkWithUsResponseView from "../views/WorkWithUsResponseView.vue";
import RegistryView from "../views/RegistryView.vue";
import RegistryResponseView from "../views/RegistryResponseView.vue";
import PolicyPrivacyView from "../views/PolicyPrivacyView.vue";
import Error404View from "../views/Error404View.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: HomeView,
  },
  {
    name: "Equipe Diretiva",
    path: "/escola/equipe-diretiva",
    component: TeamView,
  },
  {
    path: "/escola/:item",
    component: ItemCustomView,
    meta: {
      mod: "school-pages",
    },
  },
  {
    path: "/ensino/:item",
    component: ItemCustomView,
    meta: {
      mod: "education",
    },
  },
  {
    path: "/educacional/:item",
    component: ItemCustomView,
    meta: {
      mod: "educational",
    },
  },
  {
    path: "/projetos/:item",
    component: ItemCustomView,
    meta: {
      mod: "projects",
    },
  },
  {
    path: "/bolsas/:item",
    component: ItemCustomView,
    meta: {
      mod: "scholarships",
    },
  },
  {
    path: "/aluno/:item",
    component: ItemCustomView,
    meta: {
      mod: "student",
    },
  },
  {
    name: "Notícias",
    path: "/noticias",
    component: ArticlesListView,
  },
  {
    name: "Notícia",
    path: "/noticias/:item",
    component: ArticlesItemView,
  },
  {
    name: "Galerias",
    path: "/galerias-de-fotos",
    component: GalleriesListView,
  },
  {
    name: "Galeria",
    path: "/galerias-de-fotos/:item",
    component: GalleriesItemView,
  },
  {
    name: "Calendário Escolar",
    path: "/calendario-escolar",
    component: SchoolCalendarView,
  },
  {
    name: "Fale Conosco",
    path: "/fale-conosco",
    component: ContactView,
  },
  {
    name: "Obrigado!",
    path: "/fale-conosco/obrigado",
    component: ContactResponseView,
  },
  {
    name: "Trabalhe Conosco",
    path: "/trabalhe-conosco",
    component: WorkWithUsView,
  },
  {
    name: "Obrigado!",
    path: "/trabalhe-conosco/obrigado",
    component: WorkWithUsResponseView,
  },
  {
    name: "Matrícula",
    path: "/matricula",
    component: RegistryView,
  },
  {
    name: "Obrigado!",
    path: "/matricula/obrigado",
    component: RegistryResponseView,
  },
  {
    name: "Política de Privacidade",
    path: "/politica-de-privacidade",
    component: PolicyPrivacyView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "*",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
